<template>
    <div class="box-empty-home list">
        <div class="title-empty-home">{{ $t('empty_home_5') }}</div>
    </div>
</template>

<script>
import memberMixins from "@/mixins/memberMixins";
import { mapState } from "vuex";
import alertMixins from "@/mixins/alertMixins";

export default {
    name: "EventEmptyDefaultLayout",
    mixins: [memberMixins, alertMixins],
    components: {},
    props: {},
    data() {
        return {};
    },
    beforeRouterEnter() {},
    created() {},
    mounted() {},
    beforeUnmount() {},
    unmounted() {},
    computed: {},
    methods: {},
    watch: {},
};
</script>
